const hardResetHrefToResetSocketServerConnection = (url: string) => {
  window.location.href = url
}

export const redirectTo = hardResetHrefToResetSocketServerConnection

const getBotUrl = (botId: string) => `/bots/${botId}`

export const switchBot = (botId: string) => {
  hardResetHrefToResetSocketServerConnection(getBotUrl(botId))
}
